import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { DataService } from '../common/data.service';

@Injectable({
  providedIn: 'root'
})
export class ResumeService {
  constructor(private _router: Router, private http: HttpClient,private _data: DataService) { }

AddResume = (data: any): any => {
  return this._data.PostData('Resume/SaveResume', data);
}

GetResumeDetailsFilters()
{
return this._data.GetData('Resume/GetViewRequestDetailsFilters');
}

GetResumeList = (data: any): any => {
  return this._data.PostData('Resume/GetAllResumeList', data);
}

GetMyResumeList = (data: any): any => {
  return this._data.PostData('Resume/GetAllMyResumeList', data);
}


GetResume = (data: string,type:string): any => {    
  return this._data.PostData('Resume/GetResumeData', { Param1: data, Param2: type });
}

GetMarqueeDetails = (empGPN: string): any => {
  return this._data.PostData('Resume/GetMandateList', {Param1:empGPN});
}

GetMandatesByResumeId = (id: number): any => {
  return this._data.PostData('Resume/GetMandatesByResumeId', {Param1:id});
}

AddMandates= (data: any[]): any =>{  
  return this._data.PostData('Resume/AddMandates', data);  
} 
ApproveRejectResume = (data: any): any => {
  return this._data.PostData('Resume/ApproveRejectResume', data);
}
RejectForm = (data: any): any => {
  return this._data.PostData('Resume/RejectResume', data);
}
}

